import React, { useContext } from "react";
import { Backdrop, Box, CircularProgress } from "@mui/material";
import { DataContext } from "../context/DataContext";

const Loading: React.FC = () => {
  const { isLoading, icon, isDarkMode } = useContext(DataContext) as {
    isLoading: boolean;
    icon: string;
    isDarkMode: boolean;
  };

  return (
    <Backdrop
      open={isLoading}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1000,
        // Fondo translucido segun el tema en vez del negro fijo del Backdrop, para que
        // el contenido de atras siga leyendose mientras carga.
        backgroundColor: isDarkMode
          ? "rgba(12, 17, 28, 0.72)"
          : "rgba(244, 247, 252, 0.78)",
        backdropFilter: "blur(3px)",
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Anillo giratorio */}
        <CircularProgress
          size={140}
          thickness={2.2}
          disableShrink
          sx={{
            color: "#2979ff",
            // Extremos redondeados: se ve mas limpio que el corte recto por defecto.
            "& .MuiCircularProgress-circle": { strokeLinecap: "round" },
          }}
        />

        {/* Halo que late detras del logo, para que el pulso se note aunque el logo
            sea de color claro sobre fondo claro. */}
        <Box
          sx={{
            position: "absolute",
            width: 104,
            height: 104,
            borderRadius: "50%",
            backgroundColor: "#2979ff",
            animation: "crediHalo 1.8s ease-in-out infinite",
            "@keyframes crediHalo": {
              "0%, 100%": { transform: "scale(0.82)", opacity: 0.1 },
              "50%": { transform: "scale(1)", opacity: 0.22 },
            },
          }}
        />

        {/* Logo de la empresa con pulso */}
        <Box
          component="img"
          src={icon}
          alt=""
          sx={{
            position: "absolute",
            width: 78,
            height: 78,
            objectFit: "contain",
            animation: "crediPulse 1.8s ease-in-out infinite",
            "@keyframes crediPulse": {
              "0%, 100%": { transform: "scale(0.9)", opacity: 0.85 },
              "50%": { transform: "scale(1.06)", opacity: 1 },
            },
            // Respeta a quien tenga reducidas las animaciones en su sistema.
            "@media (prefers-reduced-motion: reduce)": {
              animation: "none",
            },
          }}
        />
      </Box>
    </Backdrop>
  );
};

export default Loading;
